export default __webpack_public_path__ + "static/buzie_1-91e19b897d422e8a0c5d3a07ab59f1ff.png";